import axios from './axios'
import Job from 'Models/Job'
import Bid from 'Models/Bid'
import { filter, includes, map, mapKeys, snakeCase } from 'lodash'
import BaseDataService from 'DataServices/BaseDataService'
import defer from 'Utils/defer'

function newBid (bid) {
  return new Bid(bid)
}

function newJob (job) {
  return new Job(job)
}

class Jobs extends BaseDataService {
  async getAll (params) {
    params = mapKeys(params, (value, key) => snakeCase(key))

    return axios.get(`/jobs`, { params })
      .then(response => response.data)
      .then(respData => ({
        data: map(respData.data, j => newJob(j)),
        links: respData.links,
      }))
      .catch(console.error)
  }

  async getAllPickups (params) {
    params = mapKeys(params, (value, key) => snakeCase(key))

    return axios.get(`/jobs/pickups`, { params })
      .then(response => response.data)
      .then(respData => ({
        data: map(respData.data, j => newJob(j)),
        links: respData.links,
      }))
      .catch(console.error)
  }

  async getAllForBids (params) {
    params = mapKeys(params, (value, key) => snakeCase(key))

    return axios.get(`/jobs/for_bid`, { params })
      .then(response => response.data)
      .then(respData => ({
        data: map(respData.data, j => newJob(j)),
        links: respData.links,
      }))
      .catch(console.error)
  }

  // async getById ({ id }) {
  //   return axios.get(`/jobs/${id}`)
  //     .then(response => newJob(response.data))
  //     .catch(console.error)
  // }

  async getById (id) {
    // console.log('Jobs.getById', id)
    const deferred = defer()

    if (!id) {
      console.error('Argument Missing: id is required')
    }

    const callback = (records, ids) => {
      // console.log('CALLBACK', records, ids)
      if (ids) {
        deferred.resolve(filter(records, r => includes(ids, r.id)))
      } else {
        deferred.reject([])
      }
    }

    this._createOrAddRequestToBatch(this._createDataRequest([id], callback))

    return deferred.promise
  }

  async create (event) {
    return axios.post(`/jobs`, event)
      .then(response => newJob(response.data))
      .catch(console.error)
  }

  async update (job) {
    const id = job.id
    delete job.id
    return axios.put(`/jobs/${id}`, { job: { ...job } })
      .then(response => newJob(response.data))
      .catch(console.error)
  }

  async remove (job) {
    const id = job.id
    return axios.delete(`/jobs/${id}`)
      .then(response => newJob(response.data))
      .catch(console.error)
  }

  async placeBid (jobId) {
    return axios.post(`/jobs/${jobId}/place_bid`)
      .then(response => newBid(response.data))
      .catch(console.error)
  }
}

export default new Jobs()
